export default __webpack_public_path__ + "static/media/bitsy-advisor-logo.90275577.png";